import React, { useEffect, useState } from 'react';
import CustomScrollbars from '../../../../util/CustomScrollbars';
import { Divider } from 'antd';
import ToDoItem from '../ToDoItem';
import { useDispatch, useSelector } from 'react-redux';
import { onGetReminder } from '../../../../appRedux/actions/Reminder';
import Auxiliary from '../../../../util/Auxiliary';
import IntlMessages from '../../../../util/IntlMessages';

const ToDoListForNotification = ({
  toDos,
  onTodoSelect,
  onTodoChecked,
  onMarkAsStart,
  pageIndexReset,
  refreshNotify,
}: any) => {
  const [force, setForce] = useState(true);
  const [pageIndex, setPageIndex] = useState(0);
  const [requestSent, setRequestSent] = useState(false);

  const dispatch = useDispatch();

  let pageNum = 0;
  const handleOnScrollToDo = () => {
    const parentElement = document.getElementsByClassName(
      'gx-module-content-scroll-notification',
    );

    if (!parentElement || !parentElement[0] || !parentElement[0].children[0])
      return;

    const element = parentElement[0].children[0];
    const scrollTop = (element && element.scrollTop) || document.body.scrollTop;
    const scrollHeight =
      (element && element.scrollHeight) || document.body.scrollHeight;
    const clientHeight = element.clientHeight || window.innerHeight;
    const scrolledToBottom =
      Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    if (scrolledToBottom) {
      querySearchResult();
    }
  };

  const querySearchResult = () => {
    if (requestSent) {
      return;
    }

    setTimeout(() => doQuery(), 500);
    setRequestSent(true);
  };

  const doQuery = () => {
    pageNum++;
    const append = pageNum == 0 ? false : true;
    refreshNotify(pageNum, force, append);
    // dispatch(
    //   onGetReminder({
    //     page: pageNum,
    //     onlyApproved: false,
    //     onlyforce: force,
    //     searchText: null,
    //     append: append,
    //     isNotify: true,
    //   }),
    // );
    setPageIndex(pageIndex + 1);
    setRequestSent(false);
  };

  //---------------------------------------------------
  useEffect(() => {
    window.addEventListener('scroll', handleOnScrollToDo, true);

    dispatch(
      onGetReminder({
        page: pageNum,
        categoryId: 1,
        searchText: null,
        append: false,
        isNotify: true,
      }),
    );
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener('scroll', handleOnScrollToDo, true);
    };
  }, []);

  return (
    <Auxiliary>
      <div className="ant-divider ant-divider-horizontal ant-divider-with-text ant-divider-with-text-center">
        <span className="gx-fs-xxl gx-text-orange">
          <IntlMessages id="appPublicWord.remineRemainders" />{' '}
          <span className="gx-fs-md"> </span>
        </span>
      </div>
      <CustomScrollbars
        style={{ height: '80px' }}
        className="gx-popover-scroll gx-module-content-scroll-notification"
      >
        <ul className="gx-sub-popover gx-px-0">
          {toDos &&
            toDos.pendingItems &&
            toDos.pendingItems.map((todo: any, index: number) => (
              <ToDoItem
                key={index}
                index={index}
                todo={todo}
                done={false}
                type="pendingItems"
                pageIndexReset={pageIndexReset}
                lastItemInList={toDos.pendingItems.length - 1 === index}
                onTodoSelect={onTodoSelect}
                onMarkAsStart={onMarkAsStart}
                onTodoChecked={onTodoChecked}
              />
            ))}

          {toDos &&
            toDos.doneItems &&
            toDos.doneItems.map((todo: any, index: number) => (
              <ToDoItem
                key={index}
                index={index}
                todo={todo}
                done={true}
                type="doneItems"
                pageIndexReset={pageIndexReset}
                lastItemInList={toDos.doneItems.length - 1 === index}
                onTodoSelect={onTodoSelect}
                onMarkAsStart={onMarkAsStart}
                onTodoChecked={onTodoChecked}
              />
            ))}
          {toDos &&
            toDos.reminderItems &&
            toDos.reminderItems.map((todo: any, index: number) => (
              <ToDoItem
                key={index}
                index={index}
                todo={todo}
                done={true}
                type="reminderItems"
                pageIndexReset={pageIndexReset}
                lastItemInList={toDos.reminderItems.length - 1 === index}
                onTodoSelect={onTodoSelect}
                onMarkAsStart={onMarkAsStart}
                onTodoChecked={onTodoChecked}
              />
            ))}
          {toDos &&
            toDos.archiveItems &&
            toDos.archiveItems.map((todo: any, index: number) => (
              <ToDoItem
                key={index}
                index={index}
                todo={todo}
                done={true}
                type="archiveItems"
                pageIndexReset={pageIndexReset}
                lastItemInList={toDos.archiveItems.length - 1 === index}
                onTodoSelect={onTodoSelect}
                onMarkAsStart={onMarkAsStart}
                onTodoChecked={onTodoChecked}
              />
            ))}
          {toDos &&
            toDos.noteItems &&
            toDos.noteItems.map((todo: any, index: number) => (
              <ToDoItem
                key={index}
                index={index}
                todo={todo}
                done={true}
                type="noteItems"
                pageIndexReset={pageIndexReset}
                lastItemInList={toDos.noteItems.length - 1 === index}
                onTodoSelect={onTodoSelect}
                onMarkAsStart={onMarkAsStart}
                onTodoChecked={onTodoChecked}
              />
            ))}
        </ul>
      </CustomScrollbars>
    </Auxiliary>
  );
};

export default ToDoListForNotification;
